import { CargoCriar } from "./cargo-criar";

export class CargoAlterarNormativa extends CargoCriar {
  tipoAlteracao: number;
  vagasCriadasOuReduzidas: number | null;

  constructor(obj?: any) {
    super(obj);
    this.tipoAlteracao = obj?.tipoAlteracao ?? 1;
    this.vagasCriadasOuReduzidas = obj?.vagasCriadasOuReduzidas ?? null;
  }
}
